// src/pages/UserMining.jsx
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const UserMining = () => {
  const [showStats, setShowStats] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleProceed = () => {
    setShowStats(true);
  };

  return (
    <Container
      fluid
      style={{
        maxWidth: isMobile ? '100%' : '85%',
        padding: 'clamp(1rem, 3vw, 1.5rem)',
        paddingTop: '38px',
        paddingBottom: '100px',
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
      }}
    >
      {/* Header */}
      <div className='d-flex align-items-center mb-3'>
        <i
          className='bi bi-arrow-left pe-3'
          style={{ fontSize: '1.3rem', cursor: 'pointer' }}
          onClick={() => navigate(-1)}
        ></i>
        <h5 className='m-0'>Pledge Interest</h5>
      </div>

      {/* Description */}
      <h6 className='fw-bold text-primary'>Raincoin's Mining</h6>
      <p className='text-muted' style={{ fontSize: '0.9rem' }}>
        Raincoin's mining is a product that frame by professional analyst team
        that equip by supercomputer to achieve the low risk, stable income for
        the participants.
      </p>

      {/* Highlight */}
      <div
        className='bg-white rounded p-3 mb-3'
        style={{
          border: '1px solid #e0e0e0',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        }}
      >
        <h6 className='text-center text-danger mb-3 fw-bold'>
          Product highlight
        </h6>
        <Row className='text-center'>
          <Col className='fw-bold'>Fully Automatic Operate</Col>
          <Col className='fw-bold'>Stable Income</Col>
        </Row>
      </div>

      {/* Introduction */}
      <div
        className='bg-white rounded p-3 mb-5'
        style={{
          border: '1px solid #e0e0e0',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        }}
      >
        <h6 className='text-danger fw-bold mb-2'>Project Introduction</h6>
        <ol style={{ fontSize: '0.9rem', color: '#444' }}>
          <li>
            Ethereum is a decentralized open source blockchain system with its
            own digital currency Ether...
          </li>
          <li>
            We cooperate with hardware mining companies to launch network mining
            revenue products.
          </li>
          <li>
            Pledge your USDT and we will use the equivalent ETH to participate
            in physical machine mining.
          </li>
          <li>
            This product will participate in investing in designated AI mining
            machines and share dividends.
          </li>
        </ol>
        <p className='mt-3'>
          <strong>Example:</strong> If you lock and mine 10,000U with 0.3%
          output per day, you will earn 30U daily...
        </p>
        <h6 className='text-danger fw-bold mt-4'>Project Rules</h6>
        <ul style={{ fontSize: '0.9rem', color: '#444' }}>
          <li>Pledged USDT included in snapshot.</li>
          <li>It will be auto terminated after event ends.</li>
          <li>Rate of return is an estimate.</li>
          <li>Proceeds distributed after 24 hours.</li>
          <li>Contact support to end early.</li>
        </ul>
      </div>

      {/* Proceed Button */}
      <div className='text-center fixed-bottom mb-3'>
        <Button
          variant='danger'
          className='px-5 rounded-pill fw-bold'
          style={{ backgroundColor: '#f26d6d' }}
          onClick={handleProceed}
        >
          Proceed
        </Button>
      </div>

      {/* Stats Modal */}
      <Modal show={showStats} onHide={() => setShowStats(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Pledge Interest</Modal.Title>
        </Modal.Header>
        <Modal.Body className='text-center'>
          <p className='d-flex justify-content-between'>
            <span>Funds being held in trust</span>
            <span className='text-danger fw-bold'>0 USDT</span>
          </p>
          <p className='d-flex justify-content-between'>
            <span>Expected earnings today</span>
            <span className='text-danger fw-bold'>0</span>
          </p>
          <p className='d-flex justify-content-between'>
            <span>Cumulative Income</span>
            <span className='text-danger fw-bold'>0</span>
          </p>
          <p className='d-flex justify-content-between'>
            <span>Orders in escrow</span>
            <span className='text-danger fw-bold'>0</span>
          </p>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default UserMining;
